export const GLOBAL_MESSAGES = {
  LOGIN_DATA: {
    SUCCESS: "Login successfully.",
  },
  GET_DATA: {
    POLLING: "Please wait while we fetch the data.",
    SUCCESS: "Data fetched successfully.",
  },
  UPDATE: {
    POLLING: "Please wait while we update the data.",
    SUCCESS: "Data updated successfully.",
  },
  SAVE_DATA: {
    POLLING: "Please wait while we save the data.",
    SUCCESS: "Data saved successfully.",
  },
  PDF_UPLOAD: {
    POLLING: "Please wait while we upload the data.",
    SUCCESS: "Data uploaded successfully.",
  },
  EXPORT: {
    POLLING: "Please wait while we export the data.",
    SUCCESS: "Data exported successfully. Initiating Download",
  },
  IMPORT: {
    POLLING: "Please wait while we import the data.",
    SUCCESS: "Data imported successfully.",
  },
  EXPAND_DOMAIN_OBJECT: {
    POLLING: "Please wait while we Expand Domain Object.",
    SUCCESS: "Expanded Domain Object successfully.",
  },
  DELETE: {
    POLLING: "Please wait while we delete the data.",
    SUCCESS: "Data deleted successfully.",
  },
  DISCOVER_DOMAIN_OBJECT: {
    POLLING: "Please wait while we discover Domain Object.",
    SUCCESS: "Discovered Domain Object successfully.",
  },
  TEST: {
    POLLING: "Please wait while we test the data.",
    SUCCESS: "Data tested successfully.",
  },
};
